import { isServer } from './utils';

const CHECK_LIMIT = 10;
const CHECK_WAIT = 1000;

const startChecks = (checks = 0) =>
  function check(resolve) {
    if (window.zE) return resolve(window.zE);
    if (checks > CHECK_LIMIT) return () => false;

    setTimeout(() => check(resolve), CHECK_WAIT);
  };

const getZendDesk = () => new Promise(startChecks());

export async function zE(...args) {
  if (isServer) return false;

  const zendDesk = await getZendDesk();
  zendDesk(...args);
}
